/*
 * @Description: 数字品牌价值
 * @Author: yy
 * @Date: 2019-05-31 14:47:28
 * @LastEditors: yy
 * @LastEditTime: 2019-09-19 17:39:23
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './p24.css';

import ExportHeadTitle from '../../../components/ExportHeadTitle/ExportHeadTitle';
import ExportDes from '../../../components/ExportDes/ExportDes';
import ExportFootDes from '../../../components/ExportFootDes/ExportFootDes';
import ExportEcharts from '../../../components/ExportEcharts/ExportEcharts';

import {getReportBattleDB} from '../../../controller';
import {competingGoods} from '../../../chart';
import { getSessionQuery } from '../../../utils';

class P24 extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      query: {
        brandNames: '',
        startDate: '',
        statisDate: ''
      },
      summary: {
        brandCompare: '',
        brands: []
      },
      chart: {}
    };

    this.getData = this.getData.bind(this);
  }

  componentDidMount () {
    this.getData();
  }

  getQuery () {
    const query = getSessionQuery('query');
    const result = {
      brandNames: query.brand,
      startDate: query.beginTime,
      statisDate: query.endTime
    }
    if (query.isCustom === '1') {
      result.areaIndustry = query.industry
      result.competingBrands = query.competingGoods.map(item => item.value).join(',')
    }
    return result
  }

  getData () {
    const query = this.getQuery();

    getReportBattleDB(Object.assign({report: true}, query))
      .then(data => {
        this.setState({
          query: query,
          summary: {
            brandCompare: data.brandCompare,
            brands: data.charts[data.charts.length - 1]
          },
          chart: competingGoods(data, query)
        })
      })
  }

  render() {
    const {query, summary} = this.state;
    return (
      <div className={s.container}>
        <ExportHeadTitle>数字品牌价值 – 重点竞品对比</ExportHeadTitle>

        <div>
          <ExportDes> 本周DB总值走势比较：{summary.brandCompare}。<span style={{textDecoration: 'underline'}}>菜鸟网络DB值走势略微下降。</span> </ExportDes>
        </div>

        <div className={s.echartWrapper}>
          <ExportEcharts option={this.state.chart}></ExportEcharts>
        </div>

        <ExportFootDes
          brandName={query.brandNames}
          beginTime={query.startDate}
          endTime={query.statisDate}>
        </ExportFootDes>
      </div>
    );
  }
}

export default withStyles(s)(P24);



// WEBPACK FOOTER //
// src/routes/exportPDF/p24/p24.js